/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/api/logistics.ts
 * @Description: 发货单相关API
 *
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */
import { fetch } from 'libs/fetch';
export function apiGetCityTree(option) {
  return fetch(`/api/mall/v1/mallArea/getProvinceCityTree`, {
    ...option,
    method: 'GET',
  });
}

export async function apiGetLogisticsList(option) {
  return fetch('/api/tender/v1/portal/deliveryEnquiry/search', {
    ...option,
    method: 'POST',
  });
}

export async function ticketSearch(json, isPurchaser) {
  return fetch(
    isPurchaser
      ? '/api/tender/v1/purchaser/ticket/search'
      : '/api/tender/v1/supplier/ticket/search',
    {
      json,
      method: 'POST',
    },
  );
}

export async function apiGetLogisticsFeatureList(option) {
  return fetch('/api/tender/v1/portal/deliveryEnquiry/searchLast', {
    ...option,
    method: 'POST',
  });
}
/**
 * 查询运单物流轨迹
 * @param {Object} request - 物流相关信息
 * @return {Object} res - 物流轨迹
 */
export async function getTrackDetail(request: any) {
  const res = await fetch('/api/shb/v1/waybill/trackDetail', {
    method: 'POST',
    json: request,
  });
  return res;
}

//根据时间轮询获取物流轨迹
export async function getTrackDetailPolling(request: any) {
  const res = await fetch('/api/shb/v1/waybill/realTimeTrackDetail', {
    method: 'POST',
    json: request,
  });
  return res;
}

/**
 * 查询云砼运单物流轨迹
 * @param {Object} request - 物流相关信息
 * @return {Object} res - 物流轨迹
 */
export async function getYtTrackDetail(request: any) {
  const res = await fetch('/api/shb/v1/waybill/ytTrackDetail', {
    method: 'POST',
    json: request,
  });
  return res;
}

/**
 * 查询货运平台物流轨迹
 * @param {Object} request - 物流相关信息
 * @return {Object} res - 物流轨迹
 */
export async function queryOriginDestinationTrack(sysNo) {
  const res = await fetch(`/api/lpt/v1/basic/logisticsOrder/queryOriginDestinationTrack/${sysNo}`, {
    method: 'GET',
  });
  return res;
}

/**
 * 查询货运平台物流轨迹
 * @param {Object} request - 物流相关信息
 * @return {Object} res - 物流轨迹
 */
export async function getLptTrackDetail(request: any) {
  const res = await fetch('/api/lpt/v1/logistics/logisticsWaybill/trackDetail', {
    method: 'POST',
    json: request,
  });
  return res;
}

/**
 * 获取应用信息
 * @returns {res} 应用信息
 */
export async function getDownloadInfo() {
  const res = await fetch('/api/shb/v1/applicationVersion/downloadApp', {
    method: 'POST',
    json: {},
  });
  return res;
}

/**
 * 查询采购商订单物流信息
 * @param {string | number} sysNo 运单编号
 * @return {res} 订单物流信息
 */
export async function getPurchaserDeliveryLogistics(sysNo: any) {
  const res = await fetch('/api/tender/v1/mobile/purchaser/orderDelivery/queryDeliveryLogistics', {
    method: 'POST',
    json: {
      sysNo,
    },
  });
  return res;
}

/**
 * 查询供应商订单物流信息
 * @param {string | number} sysNo 运单编号
 * @return {res} 订单物流信息
 */
export async function getSupplierDeliveryLogistics(sysNo: any) {
  const res = await fetch('/api/tender/v1/mobile/supplier/orderDelivery/queryDeliveryLogistics', {
    method: 'POST',
    json: {
      sysNo,
    },
  });
  return res;
}

// 在途运单列表
export async function apiQueryWaybillTrackList(query) {
  const res = await fetch(`/api/tender/v1/purchaser/orderDelivery/getWaybillOnRoad`, {
    json: query,
    method: 'POST',
  });
  return res;
}

// 在途运单筛选的订单列表
export async function apiQueryOrderList(query) {
  const res = await fetch(`/api/shb/v1/waybill/getOrderParamList`, {
    json: query,
    method: 'POST',
  });
  return res;
}

// 在途运单筛选的订单列表
export async function apiQueryDeliveryList(query) {
  const res = await fetch(`/api/shb/v1/waybill/getDeliveryParamList`, {
    json: query,
    method: 'POST',
  });
  return res;
}

// 在途运单筛选的订单列表
export async function apiQueryWaybillList(query) {
  const res = await fetch(`/api/shb/v1/waybill/getWaybillParamList`, {
    json: query,
    method: 'POST',
  });
  return res;
}

// 查询快递地图轨迹
export async function queryExpressMapTrack(request) {
  const res = await fetch(`/api/shb/v1/shb/track/queryMapTransferTrack`, {
    json: request,
    method: 'POST',
  });
  return res;
}
